import { ColDef } from 'ag-grid-community';
import { INTEGRATIONS } from '../../model/global-configuration.constant';

export class GridColumnsModel {
	private entity: string;

	constructor(entity: string) {
		this.entity = entity;
	}

	/**
	 * Return columns configuration.
	 * @param appScopes
	 * @param acuities
	 * @param cmpAcuities
	 * @param formFieldType
	 */
	getColumns(appScopes: Array<any>, acuities: Array<any>, cmpAcuities: Array<any>, formFieldType?: string): Array<ColDef> {
		let columns: any = [];
		switch (this.entity) {
			case INTEGRATIONS.NEXSYS:
				columns = [
					{
						headerName: 'Nexsys',
						field: 'nexsysId',
						width: 120,
						resizable: true
					},
					{
						headerName: 'AppScope',
						width: 120,
						autoHeight: false,
						cellRenderer: formFieldType ,
						cellRendererParams: {listItems: appScopes, fieldId: 'scopeId', fieldName: 'appScopeName'}
					},
					{
						headerName: 'Acuity',
						width: 120,
						cellRenderer: formFieldType ,
						cellRendererParams: {listItems: acuities, fieldId: 'acuityId', fieldName: 'acuityName'}
					},
					{
						headerName: 'Acuity CMP',
						width: 120,
						cellRenderer: formFieldType ,
						cellRendererParams: {listItems: cmpAcuities, fieldId: 'cmpAcuityId', fieldName: 'cmpAcuityName'}
					}
				];
				break;
			case INTEGRATIONS.NEXSYS_DOCUMENT_TYPES:
				columns = [
					{
						headerName: 'Nexsys',
						field: 'nexsysId',
						width: 120,
						resizable: true
					},
					{
						headerName: 'AppScope',
						width: 120,
						autoHeight: false,
						cellRenderer: formFieldType ,
						cellRendererParams: {listItems: appScopes, fieldId: 'appScopeId', fieldName: 'appScopeName'}
					},
					{
						headerName: 'Acuity',
						width: 120,
						cellRenderer: formFieldType ,
						cellRendererParams: {listItems: acuities, fieldId: 'acuityId', fieldName: 'acuityName'}
					},
					{
						headerName: 'Acuity CMP',
						width: 120,
						cellRenderer: formFieldType ,
						cellRendererParams: {listItems: cmpAcuities, fieldId: 'cmpAcuityId', fieldName: 'cmpAcuityName'}
					}
				];
				break;
			case INTEGRATIONS.VALUTRUST:
				columns = [
					{
						headerName: 'ValuTrust',
						field: 'name',
						width: 120,
						resizable: true
					},
					{
						headerName: 'AppScope',
						width: 120,
						autoHeight: false,
						cellRenderer: 'selectListCellRenderer',
						cellRendererParams: { listItems: appScopes, fieldId: 'scopeId', fieldName: 'scopeName' }
					},
					{
						headerName: 'Acuity',
						width: 120,
						cellRenderer: 'selectListCellRenderer',
						cellRendererParams: { listItems: acuities, fieldId: 'acuityId', fieldName: 'acuityName' }
					},
					{
						headerName: 'Acuity CMP',
						width: 120,
						cellRenderer: formFieldType ,
						cellRendererParams: {listItems: cmpAcuities, fieldId: 'cmpAcuityId', fieldName: 'cmpAcuityName'}
					}
				];
				break;
			case INTEGRATIONS.XPANSE:
					columns = [
						{
							headerName: 'Xpanse',
							field: 'name',
							width: 120,
							resizable: true
						},
						{
							headerName: 'AppScope',
							width: 120,
							autoHeight: false,
							cellRenderer: 'selectListCellRenderer',
							cellRendererParams: { listItems: appScopes, fieldId: 'scopeId', fieldName: 'scopeName' }
						},
						{
							headerName: 'Acuity',
							width: 120,
							cellRenderer: 'selectListCellRenderer',
							cellRendererParams: { listItems: acuities, fieldId: 'acuityId', fieldName: 'acuityName' }
						},
						{
							headerName: 'Acuity CMP',
							width: 120,
							cellRenderer: formFieldType ,
							cellRendererParams: {listItems: cmpAcuities, fieldId: 'cmpAcuityId', fieldName: 'cmpAcuityName'}
						}
					];
					break;
			case INTEGRATIONS.FNC:
				columns = [
					{
						headerName: 'FNC',
						field: 'name',
						width: 120,
						resizable: true
					},
					{
						headerName: 'AppScope',
						width: 120,
						autoHeight: false,
						cellRenderer: 'selectListCellRenderer',
						cellRendererParams: { listItems: appScopes, fieldId: 'scopeId', fieldName: 'scopeName' }
					},
					{
						headerName: 'Acuity',
						width: 120,
						cellRenderer: 'selectListCellRenderer',
						cellRendererParams: { listItems: acuities, fieldId: 'acuityId', fieldName: 'acuityName' }
					},
					{
						headerName: 'Acuity CMP',
						width: 120,
						cellRenderer: formFieldType ,
						cellRendererParams: {listItems: cmpAcuities, fieldId: 'cmpAcuityId', fieldName: 'cmpAcuityName'}
					}
				];
				break;
		}

		return columns;
	}
}
